import React, { Component } from "react";

import ReCAPTCHA from "react-google-recaptcha";

import InputText, {
  INPUT_TEXT_TYPE,
} from "components/Input/InputText/InputText";
import TLang from "model/application/Lang";

import CustomDialogForm from "../../../../components/Dialog/CustomDialogForm";

interface IPasswordLostModalProps {
  onRecoverPassword: (email: string, token: string) => void;
  onOpenClose: () => void;
  isOpen: boolean;
  lang: TLang;
}
interface IPasswordLostModalState {
  email: string;
  isOpen: boolean;
  [key: string]: any;
}

/**
 * PasswordLostModal component allows sending the email for password recovery
 */
class PasswordLostModal extends Component<
  IPasswordLostModalProps,
  IPasswordLostModalState
> {
  myRef: React.RefObject<ReCAPTCHA>;
  constructor(props: IPasswordLostModalProps) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      email: "",
      isOpen: false,
    };
  }

  /**
   * Handles input changes
   * @param {Object} e Event Object
   */
  handleInputChange = (value: any, name: string) => {
    this.setState({ [name]: value });
  };

  /**
   * Handles confirmation of creating a new app user
   */
  handleConfirmAction = async () => {
    const { email } = this.state;
    const { onRecoverPassword } = this.props;

    const token = await this.myRef.current?.executeAsync();

    onRecoverPassword(email, token ? token : "");
    this.handleClose();
  };

  /**
   * Handles the closing of modal
   */
  handleClose = () => {
    const { onOpenClose } = this.props;
    this.setState({
      email: "",
    });
    onOpenClose();
  };

  /**
   * Validation for input fields involving password recovery
   * @param {String} email
   */
  validate = (email: string) => {
    email = email ? email : "";
    return {
      email:
        email.length === 0 || !/\S+@\S+\.\S+/.test(email)
          ? "Invalid email"
          : "",
    };
  };

  confirmButtonEnabled = () => {
    const { email } = this.state;
    const errors = this.validate(email);
    // @ts-expect-error TS7053
    return !Object.keys(errors).some((x) => errors[x]);
  };

  render() {
    const { email } = this.state;
    const { isOpen, lang } = this.props;
    const errors = this.validate(email);

    const modalLang =
      lang.containers.login.subCategories.login.passwordLostModal;

    const shouldMarkError = (field: string) => {
      // @ts-expect-error TS7053
      const hasError = errors[field];
      return hasError;
    };

    return (
      <CustomDialogForm
        isOpen={isOpen}
        onClose={this.handleClose}
        title={modalLang.title ?? ""}
        onConfirmAction={this.handleConfirmAction}
        confirmBtnText={lang.modal.recover}
        description={modalLang.description}
        isDisabled={!this.confirmButtonEnabled()}
        lang={lang}
        size={"sm"}
      >
        <InputText
          error={shouldMarkError("email")}
          name="email"
          label={modalLang.inputEmail.title}
          type={INPUT_TEXT_TYPE.EMAIL}
          onChange={this.handleInputChange}
          required={true}
        />
        <div style={{ display: "none" }}>
          <ReCAPTCHA
            sitekey={getRecaptchaSiteKey()}
            size="invisible"
            ref={this.myRef}
          />
        </div>
      </CustomDialogForm>
    );
  }
}

export const getRecaptchaSiteKey = (): string => {
  let result = process.env.REACT_APP_CAPTCHA_SITEKEY
    ? process.env.REACT_APP_CAPTCHA_SITEKEY
    : "";
  if (
    (process.env.REACT_APP_ENV as string) === "development" &&
    process.env.REACT_APP_CAPTCHA_SITEKEY_DEV
  )
    result = process.env.REACT_APP_CAPTCHA_SITEKEY_DEV;
  if (
    (process.env.REACT_APP_ENV as string) === "staging" &&
    process.env.REACT_APP_CAPTCHA_SITEKEY_STAGING
  )
    result = process.env.REACT_APP_CAPTCHA_SITEKEY_STAGING;
  if (
    (process.env.REACT_APP_ENV as string) === "production" &&
    process.env.REACT_APP_CAPTCHA_SITEKEY_PROD
  )
    result = process.env.REACT_APP_CAPTCHA_SITEKEY_PROD;
  return result;
};

export default PasswordLostModal;
